import downArrow from '../images/down-arrow.svg'
import { memo } from 'react'

function ScrollDownNotice() {
  return (
    <div className="flex flex-row items-center gap-4">
      <img src={downArrow} alt="arrow pointing down" />
      <p className="text-white text-[18px] font-decimal">
        Scroll down to see more insights into the data
      </p>
    </div>
  )
}

export default memo(ScrollDownNotice)
